import React from 'react';

const Tooltip = ({ children, text, show }) => {
    return (
        <div className="ticket-page__tooltip">
            {children}
            {show && (
                <div className="ticket-page__tooltip-content">
                    {text}
                </div>
            )}

        </div>
    );
};

export default Tooltip;